/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_LedeInputs */

const en_for_whom_lede = /** @type {(inputs: For_Whom_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A trainer on their own, a studio with a team, a dietician or a physio. The schedule, payments and clients work the same, and the rest fits what you do.`)
};

const pl_for_whom_lede = /** @type {(inputs: For_Whom_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener na swoim, studio z zespołem, dietetyk albo fizjoterapeuta. Grafik, płatności i podopieczni działają tak samo, a reszta układa się pod to, czym się zajmujesz.`)
};

/**
* | output |
* | --- |
* | "A trainer on their own, a studio with a team, a dietician or a physio. The schedule, payments and clients work the same, and the rest fits what you do." |
*
* @param {For_Whom_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_lede = /** @type {((inputs?: For_Whom_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_lede(inputs)
	return en_for_whom_lede(inputs)
});